import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import theme from '../../constants/theme';

const ScrollToTop = ({ location, children }) => {
	const pathName = location.pathname.replace(/\/+$/, '');
	const mounted = useRef(pathName);

	// Scrolling to top when the location updated but not on the first mount
	// If we're entering the site at a scrolled location we don't wanna send the user
	// to the top
	useEffect(() => {
		if (mounted.current === pathName) {
			return;
		}
		mounted.current = pathName;
		setTimeout(() => {
			window.scrollTo(0, 0);
			// reset focus
			const logo = document.getElementById('logo');
			if (logo) {
				logo.focus();
				logo.blur();
			}
		}, theme.routeTransitions.exitDuration);
	}, [pathName]);
	return children;
};

export default withRouter(ScrollToTop);
